import {
  AfterViewInit, Component, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import {TabService} from '../tab.service';
import {Tab} from '../tab.model';
import {TabStyles} from '../tab-styles';
import {TabContainerData} from '../tab-container-data';

@Component({
  selector: 'spb-tab-container',
  templateUrl: './tab-container.component.html',
  providers: [TabService],
})

export class TabContainerComponent implements OnInit, OnChanges {
  @HostBinding('class.spb-tab-container') hostBaseClass = true;
  @Input() tabContainerData: TabContainerData;
  @Input() tabsToShowKeys: Tab[];
  @Input() selectedTab;
  @Input() tabStyles: TabStyles; // tabStyles for whole tab system
  @Output() onTabSelection: EventEmitter<any> = new EventEmitter();
  tabsToShowObj: Tab[];
  tabHoverStateArray: Array<boolean>;

  constructor(private tabService: TabService) {
    this.tabService.initialiseService();
  }

  ngOnInit() {
    this.initialiseTabProperties();
    this.tabHoverStateArray = Array.from(Array(this.tabsToShowKeys.length), (_, x) => false);
    this.updateTabView();
  }

  initialiseTabProperties() {
    if (!this.tabStyles) {
      this.tabStyles = {} as TabStyles;
    }

    if (!this.tabContainerData) {
      this.tabContainerData = {} as TabContainerData;
    }
  }

  selectTab(index) {
    this.selectedTab = index;
    this.tabService.updateTabSelection(this.tabsToShowObj[index]);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateTabView();
  }

  updateTabView() {
    this.tabsToShowObj = this.tabService.getTabs(this.tabsToShowKeys);
    this.selectedTab = this.selectedTab || 0;
    this.selectTab(this.selectedTab);
  }

  getTabStyles(index: number) {
    if (this.tabHoverStateArray[index] && this.selectedTab !== index) {
      return this.tabStyles.tabHoverStyle;
    } else {
      if (this.selectedTab === index) {
        return this.tabStyles.tabActiveStyle;
      } else {
        return this.tabStyles.tabStyle;
      }
    }
  }

}
